import { apiClient } from '../../lib/api-client';
import type {
  PatientCurrentStatus,
  PatientListResponse,
  PatientLookupOption,
  PatientPayload,
  PatientProfileResponse,
  PatientResponse,
  PatientStatsResponse,
  PatientUhidLookupResponse,
} from './types';

interface ListPatientParams {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: string | null;
  sortOrder?: string | null;
}

export const fetchPatients = async (params: ListPatientParams = {}) => {
  const response = await apiClient.get<PatientListResponse>('/patients', {
    params: Object.fromEntries(Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null)),
  });
  return response.data;
};

export const fetchPatientStats = async (days: 7 | 14 | 30 = 30) => {
  const response = await apiClient.get<PatientStatsResponse>('/patients/stats', {
    params: { days },
  });
  return response.data.data;
};

export const fetchPatientUhidOptions = async (search: string, limit = 50) => {
  const response = await apiClient.get<PatientUhidLookupResponse>('/patients/lookup/uhid', {
    params: { search, limit },
  });
  return response.data;
};

export const fetchPatientGlobalOptions = async (search: string, limit = 50) => {
  const response = await apiClient.get<PatientUhidLookupResponse>('/patients/lookup/global', {
    params: { search, limit },
  });
  return response.data;
};

export const fetchPatientProfile = async (patientId: string) => {
  const response = await apiClient.get<PatientProfileResponse>(`/patients/${patientId}/profile`);
  return response.data.data;
};

export const fetchPatientCurrentStatus = async (patientId: string) => {
  const response = await apiClient.get<{ success: true; data: PatientCurrentStatus }>(`/patients/${patientId}/current-status`);
  return response.data.data;
};

export const createPatient = async (payload: PatientPayload) => {
  const response = await apiClient.post<PatientResponse>('/patients', payload);
  return response.data.data;
};

export const updatePatient = async (patientId: string, payload: Partial<PatientPayload>) => {
  const response = await apiClient.patch<PatientResponse>(`/patients/${patientId}`, payload);
  return response.data.data;
};

export const archivePatient = async (patientId: string) => {
  await apiClient.delete(`/patients/${patientId}`);
};

interface ApiResponse<T> { success: true; data: T }

const compactParams = (params: object) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null),
);

export const fetchPatientLookups = async (type: 'states' | 'districts', search = '', extra: { state?: string } = {}) => {
  const response = await apiClient.get<ApiResponse<PatientLookupOption[]>>('/patients/lookups', {
    params: compactParams({ type, search, ...extra, limit: 500 }),
  });
  return response.data.data;
};
